import { Reveal } from "./motion";
import { MANIFESTO, IMAGES } from "../../data";

export const Manifesto = () => (
  <section id="manifeste" data-testid="manifesto" className="relative py-28 lg:py-40 bg-[#080E19]">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-champagne font-semibold mb-5">Notre exigence</p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl text-[#F7F5F0] leading-tight mb-8">
              Quatre principes, <span className="italic text-champagne">une seule promesse</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="spotlight rounded-2xl border border-white/10 aspect-[4/5] overflow-hidden">
              <img src={IMAGES.chauffeur} alt="Chauffeur professionnel" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700 hover:scale-105" />
            </div>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.05}>
            <div className="border-t border-white/10 py-10 grid grid-cols-[auto_1fr] gap-6 lg:gap-10 group">
              <span className="font-serif italic text-champagne/50 text-4xl lg:text-6xl group-hover:text-champagne transition-colors duration-500">{m.n}</span>
              <div>
                <h3 className="font-serif text-2xl lg:text-3xl text-[#F7F5F0] mb-3">{m.title}</h3>
                <p className="text-[#94A3B8] leading-relaxed max-w-lg">{m.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
